import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-shopify-identity',
  templateUrl: './help-shopify-identity.component.html',
  styleUrls: ['./help-shopify-identity.component.scss']
})
export class HelpShopifyIdentityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
